import { EXPIRY } from '../constants';

export function calculateExpiry(storedAt: number, location: 'fridge' | 'freezer' | 'deep-freezer'): number {
  const durations: Record<string, number> = {
    fridge: EXPIRY.FRIDGE_MS,
    freezer: EXPIRY.FREEZER_MS,
    'deep-freezer': EXPIRY.DEEP_FREEZER_MS,
  };
  return storedAt + (durations[location] || EXPIRY.FRIDGE_MS);
}

export type ExpiryStatus = 'fresh' | 'use-soon' | 'expired';

export function getExpiryStatus(expiresAt: number): ExpiryStatus {
  const now = Date.now();
  if (now >= expiresAt) return 'expired';
  const remaining = expiresAt - now;
  const oneDay = 24 * 60 * 60 * 1000;
  if (remaining < oneDay) return 'use-soon';
  return 'fresh';
}

export function formatExpiryRemaining(expiresAt: number): string {
  const remaining = expiresAt - Date.now();
  if (remaining <= 0) return 'Expired';

  const hours = Math.floor(remaining / (60 * 60 * 1000));
  const days = Math.floor(hours / 24);

  if (days > 0) return `${days}d left`;
  return `${hours}h left`;
}
